
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^[0124]$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
